import { Box, Typography } from "@mui/material";
import DataContent from "../../../components/DataContent";
import { DataCodeEnum } from "../../../constants/enum";
import PageContentEditor from "../../../components/PageContentEditor";

const IndicatorsBirthday = () => {
  return (
    <Box m={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Numerology Indicators - Birthday
        </Typography>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 80px)",
        }}
      >
        <PageContentEditor
          dataCode={DataCodeEnum.NUMEROLOGY_INDICATORS_BIRTHDAY}
          dataName={"Numerology Indicators - Birthday"}
        />
      </Box>
      {/* <DataContent
        code={DataCodeEnum.NUMEROLOGY_INDICATORS_BIRTHDAY}
        name="Numerology Indicators - Birthday"
        fields={[
          {
            code: "name",
            name: "Name",
          },
          {
            code: "description",
            name: "Description",
          },
        ]}
      /> */}
    </Box>
  );
};

export default IndicatorsBirthday;
